import React, { Component } from 'react';
import Snackbar from 'material-ui/Snackbar';
import BetfairWidgetSample from './../../samples/betfairWidgetSample';
import { literals } from '../../../languages';
import { copyToClipBoard } from '../../../utils/helpers';


class BetfairWidgetForm extends Component {
  constructor (props) {
    super(props);
    this.state = {
      generatedCode: '',
      showCopyMsg: false
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevState.generatedCode !== this.state.generatedCode || this.state.generatedCode === '') {
      this.setState({
        'generatedCode':  `<div class="tziroi-widget-root" id="tziroi-widget-root" data-clientId="${this.props.clientId}" data-productId="${this.props.productId}"></div><script type="text/javascript">document.write('<scr' + 'ipt type="text/javascript" async src="${process.env.REACT_APP_WIDGET_ASSETS_URL}/betfair-widget/js/main.min.js"></scr' + 'ipt><link rel="stylesheet" type="text/css" href="${process.env.REACT_APP_WIDGET_ASSETS_CSS_URL}${this.props.initialValues.id}.css?v=' + Date.now() + '"><link rel="stylesheet" type="text/css" href="${process.env.REACT_APP_WIDGET_ASSETS_URL}/betfair-widget/css/main.min.css">');</script>`
      });
    }
  }

  handleCopyCode = () => {
    copyToClipBoard(this.state.generatedCode);
    this.setState({
      'showCopyMsg': true
    });
  }
  
  render () {
    return(
      <div>
        {/* <div>Betfair Widget Options Soon...</div> */}
        <div className="form-divider">{literals.previewLayout[this.props.locale]}</div>
        <div className="product-preview-container"><BetfairWidgetSample locale={this.props.locale} /></div>
        <div className="form-code">
          <div className="form-code__header">
            {literals.generateCodeMessage[this.props.locale]}
          </div>
          <div onClick={this.handleCopyCode} className="copy-btn">
            <span>{literals.copy[this.props.locale]}</span>
            <i className="fa fa-clipboard" aria-hidden="true"></i>
          </div>
          <Snackbar
            open={Boolean(this.state.showCopyMsg)}
            message={this.props.locale ? <div style={{textAlign:'center'}}> {literals.copySuccessMessage[this.props.locale]} <i style={{marginLeft:'15px'}}className="fa fa-check"></i></div>  : ''}
            autoHideDuration={4000}
            onRequestClose = {()=> {this.setState({'showCopyMsg': false})}}
          />
          <pre> {this.state.generatedCode} </pre>
        </div>
      </div>
    )
  }
}


export default BetfairWidgetForm;


// WEBPACK FOOTER //
// ./src/components/clientproduct/productForms/betfairWidget.js